export default "__VITE_ASSET__B$A_j033__"